// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"5617cbbf","420":"6d0fd76c","517":"cda1b1e0","571":"2ab40adc","741":"48e4ce92"}[chunkId] + ".chunk.css";
};